import React from "react";
import PropTypes from "prop-types";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
  Checkbox,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ReactComponent as CustomUnCheckedIcon } from "../assets/images/checkbox-unchecked-icon.svg";
import { ReactComponent as CustomCheckedIcon } from "../assets/images/checkbox-checked-icon.svg";

function SelectIconComponent(props) {
  return <ExpandMoreIcon {...props} />;
}

const CSelect = ({
  name,
  label,
  value,
  onChange,
  options = [],
  placeholder = "Select...",
  helperText = "",
  disabled = false,
  multiple = false,
  className = "",
  formControlClass = "",
  error = false,
  ...other
}) => {
  return (
    <FormControl className={`custom-form-select w-full ${formControlClass}`} error={!!error}>
      {label && (
        <InputLabel id={name} shrink={!!value}>
          {label}
        </InputLabel>
      )}
      <Select
        name={name}
        labelId={name}
        IconComponent={SelectIconComponent}
        value={disabled ? (multiple ? [] : "") : value}
        onChange={onChange}
        multiple={multiple}
        displayEmpty
        disabled={disabled}
        className={`custom-select !font-[Poppins] lg:!text-sm lg:!leading-sm !text-xs !leading-xs 2xl:!h-[50px] !text-blue-700 !font-medium ${className}`}
        MenuProps={{
          classes: { paper: "custom-select-popup" },
        }}
        {...other}
      >
        <MenuItem
          value={multiple ? [] : ""}
          disabled
          className="font-normal 2xl:!text-base 2xl:!leading-base !text-sm !leading-sm"
        >
          {placeholder}
        </MenuItem>
        {options.map((item) => (
          <MenuItem
            key={item.id || item.value}
            value={item.value}
            disabled={item.disabled}
            className="font-normal 2xl:!text-base 2xl:!leading-base !text-sm !leading-sm !px-3 !py-2 hover:!bg-blue-100"
          >
            {multiple && (
              <Checkbox
                checked={Array.isArray(value) && value.includes(item.value)}
                icon={<CustomUnCheckedIcon />}
                checkedIcon={<CustomCheckedIcon />}
              />
            )}
            {item.label || item.value}
          </MenuItem>
        ))}
      </Select>
      {(!!error || helperText) && (
        <FormHelperText error={!!error}>
          {error ? error : helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

CSelect.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.node,
      disabled: PropTypes.bool,
    })
  ),
  placeholder: PropTypes.string,
  helperText: PropTypes.node,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  className: PropTypes.string,
  formControlClass: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default CSelect;
